export default "__VITE_ASSET__CPV1dbPj__"